<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
  >
    <rect
      id="사각형_3735"
      data-name="사각형 3735"
      fill="#f95b15"
      width="18"
      height="18"
      transform="translate(0 0)"
    />
    <g
      id="그룹_3761"
      data-name="그룹 3761"
      isolation="isolate"
      transform="translate(2.617 6.448)"
    >
      <path
        id="패스_1825"
        data-name="패스 1825"
        fill="#fff"
        d="M-1347.958,4725.274h1.82c1.078,0,1.939.27,1.939,1.209a1.134,1.134,0,0,1-.679,1.057v.026a1.124,1.124,0,0,1,.924,1.149c0,1-.9,1.445-2.037,1.445h-1.967Zm1.771,1.938c.532,0,.77-.216.77-.552s-.245-.493-.77-.493h-.518v1.044Zm.1,2.049c.6,0,.91-.2.91-.624,0-.4-.3-.559-.91-.559h-.623v1.182Z"
        transform="translate(1347.341 -4725.165)"
      />
      <path
        id="패스_1826"
        data-name="패스 1826"
        fill="#fff"
        d="M-1306.259,4725.274h1.351l.826,2.108c.1.283.189.591.287.893h.035c.1-.3.189-.61.287-.893l.8-2.108h1.358v4.887h-1.141v-1.675a15.291,15.291,0,0,1,.161-1.695h-.028l-.434,1.169-.7,1.787h-.686l-.707-1.787-.42-1.169h-.028a15.262,15.262,0,0,1,.161,1.695v1.675h-1.12Z"
        transform="translate(1310.181 -4725.165)"
      />
      <path
        id="패스_1827"
        data-name="패스 1827"
        fill="#fff"
        d="M-1253.639,4725.274h1.827c1.148,0,2.093.381,2.093,1.589,0,1.163-.959,1.675-2.058,1.675h-.609v1.623h-1.253Zm1.8,2.338c.609,0,.9-.269.9-.749s-.336-.663-.938-.663h-.511v1.412Z"
        transform="translate(1263.102 -4725.165)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 18,
    },
  },
};
</script>
